// extracted by mini-css-extract-plugin
module.exports =  {"ui-recruiter-notes":"RecruiterNotes-module_ui-recruiter-notes_d816b","ui-recruiter-notes__label":"RecruiterNotes-module_ui-recruiter-notes__label_d2dc2"};